export const PLATFORM_ANDROID = "android";
export const PLATFORM_IOS = "ios";

export const AUDIO_POLICY_ALWAYS_MUTE = "always-mute";
export const AUDIO_POLICY_ON_INTERACTION = "on-interaction";
export const AUDIO_POLICY_NO_RESTRICTIONS = "no-restrictions";

// TODO(Casey): Use constants instead of string literals for all exchanges
// throughout.
export const EXCHANGE_ADPOPCORN = "adpopcorn";
export const EXCHANGE_APPLOVIN = "applovin";
export const EXCHANGE_CONNATIX = "connatix";
export const EXCHANGE_DOUBLECLICK = "doubleclick";
export const EXCHANGE_INNERACTIVE = "inneractive-direct";
export const EXCHANGE_IRONSOURCE = "ironsource";
export const EXCHANGE_MINTEGRAL = "mintegral";
export const EXCHANGE_MOMENTO = "momento";
export const EXCHANGE_PANGLE = "pangle";
export const EXCHANGE_VERVE = "verve";
export const EXCHANGE_VUNGLE = "vungle";
export const EXCHANGE_XIAOMI = "xiaomi";

export const ORIENTATION_PORTRAIT = "portrait";
export const ORIENTATION_LANDSCAPE = "landscape";

// These must correspond to the rtb.proto ConnectionType enum definition.
export const CONNECTION_TYPE_WIFI = 2;

// These must correspond to the rtb.proto ClickAreaType enum definition.
export const CLICK_AREA_TYPE_OTHER = 1;
export const CLICK_AREA_TYPE_CTA = 3;

export const CLICK_METRIC_TYPE_CLOSE = "CLOSE";
export const CLICK_METRIC_TYPE_CTA = "CTA";
export const CLICK_METRIC_TYPE_DEADZONE = "DEADZONE";
export const CLICK_METRIC_TYPE_UNKNOWN = "UNKNOWN_CLICK_TYPE";

// This must correspond to the rtb.proto ClickRejectionReason enum definition.
export const CLICK_REJECTION_REASON_UNKNOWN = 0;
export const CLICK_REJECTION_REASON_NO_INTERACTIONS = 1;

// This must correspond to the auction.proto ClickthroughURLType.
export const CLICKTHROUGH_URL_TYPE_LIFTOFF_ENDPOINT = 1;
export const CLICKTHROUGH_URL_TYPE_APP_STORE = 2;

// This must correspond to the auction.proto ClickTrackingURLType.
export const CLICK_TRACKING_URL_TYPE_UNKNOWN = 0;
export const CLICK_TRACKING_URL_TYPE_LIFTOFF_ENDPOINT = 1;

// This must correspond to the rtb.proto TrackingMethod enum definition.
export const TRACKING_METHOD_OPEN_METHOD = 1;
export const TRACKING_METHOD_IMAGE = 2;
export const TRACKING_METHOD_BEACON = 3;

export const AUTOCLICK_TYPE_LAST_INTERACTION = "lastInteraction";
export const AUTOCLICK_TYPE_INTERACTION_COUNT = "interactionCount";
export const AUTOCLICK_TYPE_LAST_INTERACTION_AND_INTERACTION_COUNT =
  "lastInteractionAndInteractionCount";
export const AUTOCLICK_TYPE_COMPLETED_DELAY = "completedDelay";
export const AUTOCLICK_TYPE_LOAD_DELAY = "loadDelay";
export const AUTOCLICK_TYPE_VIEWABLE_DELAY = "viewableDelay";
export const AUTOCLICK_TYPE_VIEWABLE_DELAY_WITH_RESET =
  "viewableDelayWithReset";

export const CLICK_OPEN_METHOD_MRAID = "mraid";
export const CLICK_OPEN_METHOD_ANCHOR = "anchor";
export const CLICK_OPEN_METHOD_LOCATION = "location";



// WEBPACK FOOTER //
// ./src/js/constants.js